'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('requested-user-list', {
      url: '/users/requested/:type',
      template: '<requested-user-list></requested-user-list>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/admin/requested-user-list/requested-user-list.routes.js